<template lang="pug">
.v-breadcrumbs.breadcrumbs(v-if="data")
	.breadcrumbs__list
		li.breadcrumbs__list-item(v-for="(item, i) in data.items")
			component.breadcrumbs__item(:is="item.link ? 'a' : 'span'" v-show="!item.hidden" :href="item.link") {{item.text}}
			v-svg-icon.breadcrumbs__arrow(v-if="i < data.items.length - 1" v-show="!item.hidden" icon="simple-arrow-right")
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}
</script>